import { createContext, useContext } from 'react'
import {
  CertificateProgramEngagementActionType,
  type CertificateProgramEngagement,
} from '@mc/api'
import { type PromoVariables } from 'pages/certificates/promo'

const isPurchaseCtaEnabled = (
  engagement: CertificateProgramEngagement | undefined,
  promoVariables: PromoVariables | null | undefined,
): boolean => {
  if (promoVariables?.cta) return true
  if (engagement?.emailCapture) return false
  if (engagement?.notice) return false
  return !!engagement?.actionBlock?.actions?.some(
    (action) =>
      action.actionType ===
      CertificateProgramEngagementActionType.PURCHASE_CERTIFICATE,
  )
}

const IsPurchaseCtaEnabledContext = createContext<boolean | null>(null)

export const IsPurchaseCtaEnabledProvider = ({
  promoVariables,
  engagement,
  children,
}: {
  promoVariables: PromoVariables | null | undefined
  engagement: CertificateProgramEngagement | undefined
  children: React.ReactNode
}) => (
  <IsPurchaseCtaEnabledContext.Provider
    value={isPurchaseCtaEnabled(engagement, promoVariables)}
  >
    {children}
  </IsPurchaseCtaEnabledContext.Provider>
)

export const useIsPurchaseCtaEnabled = () => {
  const context = useContext(IsPurchaseCtaEnabledContext)
  if (context === null) {
    throw new Error(
      'useIsPurchaseCtaEnabled must be used within a IsPurchaseCtaEnabledProvider',
    )
  }
  return context
}
